/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "social-facebook-square-3b03c0b8--sprite",
  "use": "social-facebook-square-3b03c0b8--sprite-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 36 36\" id=\"social-facebook-square-3b03c0b8--sprite\">\r\n  <defs>\r\n    <clipPath id=\"social-facebook-square-3b03c0b8--sprite_clip-path\">\r\n      <rect width=\"19\" height=\"19\" fill=\"none\" />\r\n    </clipPath>\r\n    <clipPath id=\"social-facebook-square-3b03c0b8--sprite_clip-Social_Facebook\">\r\n      <rect width=\"36\" height=\"36\" />\r\n    </clipPath>\r\n  </defs>\r\n  <g id=\"social-facebook-square-3b03c0b8--sprite_Social_Facebook\" clip-path=\"url(#social-facebook-square-3b03c0b8--sprite_clip-Social_Facebook)\">\r\n    <g id=\"social-facebook-square-3b03c0b8--sprite_Group_19866\" data-name=\"Group 19866\">\r\n      <g id=\"social-facebook-square-3b03c0b8--sprite_Group_19865\" data-name=\"Group 19865\" transform=\"translate(0 0)\">\r\n        <rect id=\"social-facebook-square-3b03c0b8--sprite_Rectangle_3070\" data-name=\"Rectangle 3070\" width=\"36\" height=\"36\" rx=\"18\" fill=\"#e0e7f4\" opacity=\"0\" />\r\n      </g>\r\n    </g>\r\n    <g id=\"social-facebook-square-3b03c0b8--sprite_Component_2\" data-name=\"Component 2\" transform=\"translate(9 9)\" clip-path=\"url(#social-facebook-square-3b03c0b8--sprite_clip-path)\">\r\n      <path id=\"social-facebook-square-3b03c0b8--sprite_Path_2950\" data-name=\"Path 2950\" d=\"M17.95,0H1.05A1.05,1.05,0,0,0,0,1.05v16.9A1.05,1.05,0,0,0,1.05,19h9.1V11.667H7.667V8.777h2.47V6.667a3.455,3.455,0,0,1,3.687-3.793A20.705,20.705,0,0,1,16.05,3V5.563H14.537c-1.19,0-1.42.563-1.42,1.393V8.79h2.85l-.37,2.877h-2.48V19H17.95A1.05,1.05,0,0,0,19,17.95h0V1.05A1.05,1.05,0,0,0,17.95,0Z\" fill=\"currentColor\" />\r\n    </g>\r\n  </g>\r\n</symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
